(function () {
  window.BMap_loadScriptTime = new Date().getTime();
  document.write('<script type="text/javascript" src="http://api.map.baidu.com/getscript?v=1.3&ak=&services=&t=20170328122103"></script>');
  // document.write('<link rel="stylesheet" type="text/css" href="http://api.map.baidu.com/res/13/bmap.css"/>');
})();



// WEBPACK FOOTER //
// ./src/map_module/bmap/bmapLoader.js